import { POST } from '@/server/http';
import URLS from '@/server/urls';

export default async (options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.config.getAll, {}, options);
    if (error) return { error, status };
    return content || {};
};
